import * as yup from "yup";

export const sftpConnectionSchema = yup.object({
  connection: yup.object({
    connectionName: yup
      .string()
      .trim("Please Remove Spaces")
      .strict()
      .required("Please Select Connections!"),
    renameConnectionsName: yup.lazy((value) => {
      switch (typeof value) {
        case "string":
          return yup
            .string()
            .label("renameConnectionsName")
            .required("Please Enter Rename Connections Name")
            .trim("Please Remove Spaces")
            .strict();
        case "object":
          return yup.string().nullable();
        default:
          return yup.string();
      }
    }),

    host: yup
      .string()
      .trim("Please Remove Spaces")
      .strict(true)
      .required("Please Input Your Host!"),
    connectionType: yup.string().required("Please Select Connection Type!"),
    port: yup
      .number()
      .positive("Connection port must be a positive number")
      .typeError("Please Input Port Of Connection!")
      .required("Please Input Port Of Connection!")
      .min(1, "Connection port must be a positive number"),
    retryTimes: yup
      .number()
      .typeError("Retry Times must be a number")
      .integer()
      .required("Please Input Retry Times Of Connection!"),
    connectTimeout: yup
      .number()
      .typeError("Connect Timeout must be a number")
      .integer()
      .required("Please Input Your Connection Timeout!"),
    disconnectTimeout: yup
      .number()
      .typeError("Disconnect Timeout must be a number")
      .integer()
      .required("Please Input Your Disconnect Timeout!"),
    downloadZeroBytes: yup.bool(),
    forceIPv4: yup.bool(),
    isPassive: yup.bool(),
    authType: yup.string().required("Please Select Authenticate Type!"),
    username: yup
      .string()
      .trim("Please Remove Spaces")
      .strict(true)
      .required("Please Enter User Name!"),
    privateKey: yup.lazy((value) => {
      switch (typeof value) {
        case "string":
          return yup.string().when("authType", {
            is: "PrivateKey",
            then: yup
              .string()
              .trim("Please Remove Spaces")
              .strict(true)
              .required("Please Enter Private Key!")
              .matches(
                /-----BEGIN RSA PRIVATE KEY-----/,
                "Please Enter OPENSSH  Key!",
              ),
          });
        case "object":
          return yup.string().nullable().notRequired();
        default:
          return yup.string();
      }
    }),
    privateKeyPassword: yup.lazy((value) => {
      switch (typeof value) {
        case "string":
          return yup.string().when("authType", {
            is: "PrivateKey",
            then: yup
              .string()
              .trim("Please Remove Spaces")
              .strict(true)
              .required("Please Enter Private Key Password!"),
          });
        case "object":
          return yup.string().nullable().notRequired();
        default:
          return yup.string();
      }
    }),
    password: yup.lazy((value) => {
      switch (typeof value) {
        case "string":
          return yup.string().when("authType", {
            is: "Password",
            then: yup
              .string()
              .trim("Please Remove Spaces")
              .strict(true)
              .required("Please Enter Password!"),
          });
        case "object":
          return yup.string().nullable().notRequired();
        default:
          return yup.string();
      }
    }),
  }),
});

export const sftpJobSchema = yup.object().shape({
  job: yup.object({
    jobName: yup
      .string()
      .trim()
      .required("Please Input Your Job Name!")
      .matches(
        /^[a-zA-Z0-9@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
        "Please Follow This Format (word_number or wordNumber)!",
      ),
    jobName1: yup
      .string()
      .trim()
      .matches(
        /^[a-zA-Z0-9@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
        "Please Follow This Format (word_number or wordNumber)!",
      ),
    managemetGroupId: yup
      .string()
      .required("Please Select Hotel Management Group!"),
    projectOId: yup.string().required("Please Select The Project!"),
    schedules: yup
      .array()
      .of(
        yup.object().shape({
          cron: yup
            .string()
            .trim()
            .matches(
              /(?<=cron\()[^\s]+/i,
              "Please Use Following Format - ex:-cron(0 12 * * ? *)",
            )
            .required("Please Enter Cron!"),
          description: yup.string().required("Please Enter Description!"),
        }),
      )
      .min(1, "Please Add A schedule!")
      .max(1, "Exceeded maximum no of schedules!"),

    processType: yup.string().required("Please Select Process Type!"),
    timezone: yup.string().required("Please Select Time Zone !"),
    connections: yup.array().min(1, "Please Select Connection!"),
    connectTimeout: yup.number().when("isConnectionOverrides", {
      is: true,
      then: yup.number().required("Please Input Your Connection Timeout!"),
    }),
    disconnectTimeout: yup.number().when("isConnectionOverrides", {
      is: true,
      then: yup.number().required("Please Input Your Disconnect Timeout!"),
    }),
    jobParameters: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required("Please Input Parameter Name!"),
          type: yup.string().required("Please Select Parameter Type!"),
          dateCalc: yup.number().when("type", {
            is: "Date",
            then: yup.number().required("Please Input Your Date Calc Value!"),
          }),
          dateFormat: yup.string().when("type", {
            is: "Date",
            then: yup.string().required("Please Input Your Date Format Value!"),
          }),
          fixedvalue: yup.string().when("type", {
            is: "Fixed",
            then: yup.string().required("Please Input Your Fixed Value!"),
          }),
          listvalue: yup.string().when("type", {
            is: "List",
            then: yup.string().required("Please Input Your List of Values!"),
          }),
          formatPatternString: yup.string().when("type", {
            is: "Formatted",
            then: yup
              .string()
              .required("Please Input Your Format Pattern String!"),
          }),
        }),
      )
      .min(1, "Must have At least One Job Parameter!"),

    serverPath: yup.object().shape({
      rootPath: yup.string().required("Please Input Your Root Path!"),
      dynamicPathSegments: yup.array().of(
        yup.object().shape({
          segmentType: yup
            .string()
            .required("Please Select Your Segment Type!"),
          segmentValue: yup.string().when("type", {
            is(type) {
              if (type === "Fixed") {
                return true;
              }
              if (type === "Parameter") {
                return true;
              }
              return false;
            },
            then: (schema) =>
              schema.required("Please Input Your Segment Value!").nullable(),
          }),
        }),
      ),
    }),
    fileSelection: yup.object().shape({
      fileExtensions: yup
        .array()
        .min(1, "Please Input Your List of File Extensions!"),
      dateModified: yup.object().shape({
        dateType: yup
          .string()
          .nullable()
          .typeError("Please Select Your Override Date Format!"),
        dateValue: yup
          .number()
          .nullable()
          .when("dateType", {
            is(dateType) {
              if (
                dateType === "Days" ||
                dateType === "Hours" ||
                dateType === "Minutes"
              ) {
                return true;
              }
              return false;
            },
            then: (schema) => schema.typeError("Please Enter Date Value!"),
          }),
      }),

      fileNameSelectionType: yup
        .string()
        .required("Please Select File Name Selection Type!"),
      fileNameSelectionValue: yup
        .string()
        .nullable()
        .when("fileNameSelectionType", {
          is(fileNameSelectionType) {
            if (
              fileNameSelectionType === "BeginsWith" ||
              fileNameSelectionType === "EndsWith" ||
              fileNameSelectionType === "Contains" ||
              fileNameSelectionType === "Regex"
            ) {
              return true;
            }
            return false;
          },
          then: (schema) => console.log(schema, "schema"),
        }),
      fileNameSelectionSegments: yup
        .array()
        .of(
          yup.object().shape({
            segmentType: yup
              .string()
              .required("Please Select Your Segment Type!"),
            segmentValue: yup.string().when("type", {
              is(type) {
                if (type === "Fixed" || type === "Parameter") {
                  return true;
                }
                return false;
              },
              then: (schema) =>
                schema.required("Please Input Your Segment Value!"),
            }),
          }),
        )
        .required("Must have File Name Selection Segments"),

      fileNameSelectionSegmentMatchType: yup
        .string()
        .required("Please Select File Name Selection Segment Match Type!"),
    }),
    extensionChanges: yup
      .array()
      .of(
        yup.object().shape({
          from: yup
            .string()
            .required(
              "Please Input Original / Existing / From File Extension!",
            ),
          to: yup
            .string()
            .required("Please Input Required / To File Extension!"),
        }),
      )
      .min(1, "Must have File Extension Changes!"),
    fileNameProcessing: yup.object().shape({
      processingRules: yup.array().of(
        yup.object().shape({
          ruleType: yup.string().required(" Please Select Your Rule Type!"),
          trimCount: yup.string().when("ruleType", {
            is: "Trim" || "TrimStart" || "TrimEnd",
            then: yup.string().required("Please Input Your Trim Count!"),
          }),

          replaceText: yup.string().when("ruleType", {
            is: "FindAndReplace",
            then: yup.string().required("Please Input Your Replace Text!"),
          }),
          replaceWithText: yup.string().when("ruleType", {
            is: "FindAndReplace",
            then: yup
              .string()
              .required("Please Input Your Replace With Text Value!"),
          }),

          appendType: yup.string().when("ruleType", {
            is: "AppendAtStart" || "AppendAtEnd",
            then: yup.string().required("Please Select Your Append Type!"),
          }),

          appendText: yup.string().when("appendType", {
            is: "Text",
            then: yup.string().required("Please Input Your Append Text!"),
          }),

          appendDateFormat: yup.string().when("appendType", {
            is: "BusinessDate" || "RunDate",
            then: yup
              .string()
              .required("Please Input Your Append Date Format!"),
          }),
        }),
      ),
    }),
    indexExtraction: yup.object().shape({
      fileNameSegmentSeparator: yup
        .string()
        .required("Please Select Your File Name Segment Separator!"),
      indexExtractionList: yup
        .array()
        .of(
          yup.object().shape({
            indexId: yup
              .string()
              .required(" Please Select Your Index !")
              .nullable(),
            indexType: yup
              .string()
              .required(" Please Select Your Index Type !")
              .nullable(),
            inputDateTimeFormat: yup.string().when("indexType", {
              is: "Date",
              then: yup
                .string()
                .required("Please Select Your Override Date Format!"),
            }),
            inputDateCalc: yup.string().when("indexType", {
              is: "Date",
              then: yup.string().required("Please Input Your Date Calc!"),
            }),
            mappingType: yup
              .string()
              .required(" Please Select Your Mapping Type !")
              .nullable(),
            dirLevel: yup.number().when("mappingType", {
              is: "DirLevel",
              then: yup
                .number()
                .required("Please Input Your Directory Levels !"),
            }),
            fileSeg: yup.number().when("mappingType", {
              is: "FileSegment",
              then: yup
                .number()
                .required("Please Input Your File Segment Count !"),
            }),
            dateCalc: yup.number().when("mappingType", {
              is: "DateCalc",
              then: yup.number().required("Please Input Your Date Calc !"),
            }),
            fixed: yup.string().when("mappingType", {
              is: "Fixed",
              then: yup.string().required("Please Input Your Fixed Value !"),
            }),
            parameterName: yup.string().when("mappingType", {
              is: "Parameter",
              then: yup.string().required("Please Input Your Parameter Name !"),
            }),
            fileProp: yup.string().when("mappingType", {
              is: "FileProp",
              then: yup
                .string()
                .required("Please Input Your File Property Value !"),
            }),
            FilePropType: yup.string().when("mappingType", {
              is: "FileProp",
              then: yup
                .string()
                .required("Please Input Your File Property Type !"),
            }),
          }),
        )
        .min(1, "Must have Index Extraction List!"),
    }),
    mapping: yup.object().shape({
      hotelIndexName: yup.string().required("Please Select Your Index Name!"),
      mappingDataSource: yup
        .string()
        .required("Please Select Your Mapping Data Source!"),
      dataPopulationStrategy: yup
        .string()
        .required("Please Select Your Data Population Strategy!"),
    }),
    statusUpdate: yup.object().shape({
      destinations: yup.array().min(1, "Please Select Your Destinations!"),
    }),
  }),
});

export const SFTPLogSchema = yup.object().shape({
  jobId: yup.string().required("Please Select Job Name!"),
  businessDate: yup
    .array(yup.date())
    .nullable()
    .required("Please Select Date Range!"),
});
export default {
  sftpConnectionSchema,
  sftpJobSchema,
  SFTPLogSchema,
};
